
import { Options, Vue } from "vue-class-component";
import { store } from "@/store";
import SideMenu from "@/components/WorkBench/SideMenu.vue";
import Paging from "@/components/Paging.vue";
import {
  alert_re_chinese,
  dateConversion,
  getLocalProject,
  regChineseObJ,
} from "@/utils";
import { readUserProfile } from "@/store/main/getters";
import { readMyProjects, readProjectScenesPage } from "@/store/project/getters";
import {
  dispatchCreateProjectScenes,
  dispatchDeleteProjectScene,
  dispatchGetProjectScenesPage,
  dispatchUpdateProjectScene,
} from "@/store/project/actions";

@Options({
  components: {
    SideMenu,
    Paging,
  },
})
export default class ProjectSceneManage extends Vue {
  localProject = getLocalProject()
  genderOptions = {
    0: '默认',
    1: '男',
    2: '女',
  }

  public sceneForm = {
    id: "",
    original_scene_id: "",
    chinese: "",
    gender: 0,
    project: "",
  };
  public size = 16; // 每页最大数
  public current_page = 1; // 当前页码
  public totalNum = 0;

  public search = "";
  public loading = false;
  public dialogVisible = false;
  //public project = Number(getLocalProject());
  get project() {
    return (this.$route as any).query.project
  }

  // 新增场景脚本
  public addSceneForm = {
    original_scene_id: "",
    gender: 0,
    oldWeapons: false,
    chinese: "",
  };

  public async mounted() {
    this.loading = true;
    // await dispatchGetProjectScenesPage(store, {
    //   project: this.project,
    //   size: this.size,
    //   page: this.current_page,
    //   search: this.search,
    // });
    await this.onPaging(this.size, 1);
    this.loading = false;
  }

  // 判断是否是管理员
  public get get_is_super() {
    let judge = true;
    let MyProject = readMyProjects(store).filter(
      (item: any) => item.project.id == this.project
    )[0]?.is_project_admin;
    if (readUserProfile(store)?.is_super) {
      judge = false;
    } else if (MyProject) {
      judge = false;
    } else {
      judge = true;
    }
    return judge;
  }
  handleEdit(row: any, sceneForm: any) {
    if (!row.isEdit) {
      row.isEdit = !row.isEdit;
      row.handleEditText = "取消";
      row.info = "info";
      row.isDanger = "primary";
      row.handleDeleteText = "提交";
      row.handleConfirmText = "确认更改场景?";
    } else {
      row.isEdit = !row.isEdit;
      row.isDanger = "danger";
      row.info = "warning";
      row.handleEditText = "编辑";
      row.handleDeleteText = "删除";
      row.handleConfirmText = "确认删除场景?";
    }
  }
  //编辑, 删除
  public async handleDeleteScene(row: any, sceneForm: any) {
    if (row.handleDeleteText === "提交") {
      // todo: 以更好的方式获取input selece value
      const commitForm: any = {};
      commitForm.project = row.project;
      commitForm.id = row.id;
      commitForm.chinese = (document.getElementById(
        "chinese" + row.id
      ) as any).value;
      commitForm.original_scene_id = (document.getElementById(
        "original_scene_id" + row.id
      ) as any).value;

      if (this.project == 34) {
        commitForm.mark = row.gender
      }
      if (this.project == 42) {
        commitForm.mark = row.oldWeapons ? 1 : 0
      }
      if (this.project == 57) {
        commitForm.level = (document.getElementById(
          "level" + row.id
        ) as any).value;
        commitForm.quality = (document.getElementById(
          "quality" + row.id
        ) as any).value;
      }
      if (this.project == 59) {
        commitForm.order_id = (document.getElementById(
          "order_id" + row.id
        ) as any).value

        if (commitForm.order_id === "") {
          alert("order_id不能为空");
          return;
        }
      }

      if (commitForm.chinese === "") {
        alert("场景名称不能为空");
        return;
      }
      if (commitForm.original_scene_id === "") {
        alert("original_scene_id不能为空");
        return;
      }
      // if (!regChineseObJ.test(commitForm.chinese)) {
      //   alert_re_chinese("场景名称");
      //   return;
      // }

      await dispatchUpdateProjectScene(store, commitForm);
    } else {
      await dispatchDeleteProjectScene(store, {
        id: row.id,
        project: row.project,
      });
      this.onPaging(this.size, 1);
    }

    await dispatchGetProjectScenesPage(store, {
      project: this.project,
      size: this.size,
      page: this.current_page,
      search: this.search,
    });
  }

  public get project_scene_page() {
    return readProjectScenesPage(store);
  }

  getProjectScenes(search: string) {
    let scene_list: any[] = readProjectScenesPage(store).results;
    scene_list.forEach(row => {
      if (this.project == 42) {
        row.oldWeapons = !!row.mark
      }
      if (this.project == 34) {
        row.gender = row.mark
      }
    })

    for (let scene of scene_list) {
      scene.created = dateConversion(new Date(scene.created).getTime());
      scene.isEdit = false;
      scene.handleEditText = "编辑";
      scene.handleDeleteText = "删除";
      scene.handleConfirmText = "确定删除账号？";
      scene.isDanger = "danger";
      scene.info = "warning";
    }
    return scene_list;
  }

  public async submitForm() {
    let FormVal = {
      original_scene_id: this.addSceneForm.original_scene_id,
      chinese: this.addSceneForm.chinese,
      mark: this.project == 34 ? this.addSceneForm.gender : (this.addSceneForm.oldWeapons ? 1 : 0),
      project: this.project,
    };
    await dispatchCreateProjectScenes(store, FormVal);
    await dispatchGetProjectScenesPage(store, {
      project: this.project,
      size: this.size,
      page: this.current_page,
      search: this.search,
    });
    await this.onPaging(this.size, 1);
    this.dialogVisible = false;
  }

  // 分页
  public async onPaging(size: any, page: any) {
    this.loading = true;
    this.current_page = page;
    this.size = size;

    await dispatchGetProjectScenesPage(store, {
      project: this.project,
      size: this.size,
      page: this.current_page,
      search: this.search,
    });
    this.totalNum = this.project_scene_page.count;
    this.loading = false;
  }

  // 查询
  public async onSearch() {
    this.loading = true;
    // await dispatchGetProjectScenesPage(store, {
    //   project: this.project,
    //   size: this.size,
    //   page: this.current_page,
    //   search: this.search,
    // });
    await this.onPaging(this.size, 1);
    this.loading = false;
  }
}
